export enum RecentSearchesPageKey {
  Profiles = "profiles",
  WorkflowRoles = "workflow_roles",
  WorkflowEngagements = "workflow_engagements",
  ActivityInterested = "activity_interested",
  ActivityMatches = "activity_matches",
  ActivityShortlist = "activity_shortlist",
  AnalyticsExport = "analytics_export",
  AnalyticsConfig = "analytics_config",
  AuditPlanner = "audit_planner",
  BookingModuleProjectsRoles = "booking_module_projects_roles",
  BookingModuleProjectsEngagements = "booking_module_projects_engagements",
  BookingModuleWorkforce = "booking_module_workforce",
  MarketplaceWorkOpportunities = "marketplace_work_opportunities",
  ProfileSkills = "profile_skills",
  BookingsCalendar = "bookings_calendar",
  BookingCategories = "booking_categories",
  BookingCalendars = "booking_calendars",
  SkillsDomains = "skills_domains",
  SkillsDomainSkills = "skills_domain_skills",
  SkillsFrameworks = "skills_frameworks",
  CustomValues = "custom_values",
  ReassignProfile = "reassign_profile",
  CollaboratorsConfigs = "collaborators_configs",
  ManageRolesSuggestedProfiles = "manage_roles_suggested_profiles",
  ManualAllocations = "manual_allocations",
  ManualAllocationsRoles = "manual_allocations_roles",
  TransferEngagements = "transfer_engagements",
  AdminKPIConfiguration = "admin_kpi_configuration",
  NotificationsSettings = "notifications_settings"
}
export type RecentSearch = {
  value: string;
  timestamp: number;
};
